import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _DLightbox_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
/* import __COLOCATED_TEMPLATE__ from './d-lightbox.hbs'; */
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import { ANIMATION_DURATION, KEYBOARD_SHORTCUTS, LAYOUT_TYPES, LIGHTBOX_APP_EVENT_NAMES, LIGHTBOX_ELEMENT_ID, SWIPE_DIRECTIONS, TITLE_ELEMENT_ID } from "discourse/lib/lightbox/constants";
import { createDownloadLink, getSwipeDirection, openImageInNewTab, preloadItemImages, scrollParentToElementCenter, setCarouselScrollPosition, setSiteThemeColor } from "discourse/lib/lightbox/helpers";
import discourseLater from "discourse-common/lib/later";
import { bind } from "discourse-common/utils/decorators";
import TEMPLATE from "./d-lightbox.hbs";
import { setComponentTemplate } from "@ember/component";
let DLightbox = (_class = (_DLightbox_brand = /*#__PURE__*/new WeakSet(), class DLightbox extends Component {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _DLightbox_brand);
    _initializerDefineProperty(this, "appEvents", _descriptor, this);
    _initializerDefineProperty(this, "items", _descriptor2, this);
    _initializerDefineProperty(this, "isVisible", _descriptor3, this);
    _initializerDefineProperty(this, "isLoading", _descriptor4, this);
    _initializerDefineProperty(this, "currentIndex", _descriptor5, this);
    _initializerDefineProperty(this, "currentItem", _descriptor6, this);
    _initializerDefineProperty(this, "isZoomed", _descriptor7, this);
    _initializerDefineProperty(this, "isRotated", _descriptor8, this);
    _initializerDefineProperty(this, "isFullScreen", _descriptor9, this);
    _initializerDefineProperty(this, "rotationAmount", _descriptor10, this);
    _initializerDefineProperty(this, "hasCarousel", _descriptor11, this);
    _initializerDefineProperty(this, "hasExpandedTitle", _descriptor12, this);
    _defineProperty(this, "options", {});
    _defineProperty(this, "callbacks", {});
    _defineProperty(this, "willClose", false);
    _defineProperty(this, "elementId", LIGHTBOX_ELEMENT_ID);
    _defineProperty(this, "titleElementId", TITLE_ELEMENT_ID);
    _defineProperty(this, "animationDuration", ANIMATION_DURATION);
    _defineProperty(this, "scrollPosition", 0);
  }
  get layoutType() {
    return window.innerWidth > window.innerHeight ? LAYOUT_TYPES.HORIZONTAL : LAYOUT_TYPES.VERTICAL;
  }
  get CSSVars() {
    const base = "--d-lightbox-image";
    const variables = [`${base}-animation-duration: ${this.animationDuration}ms;`];
    if (!this.currentItem) {
      return htmlSafe(variables.join(""));
    }
    const {
      width,
      height,
      aspectRatio,
      dominantColor,
      fullsizeURL
    } = this.currentItem;
    variables.push(`${base}-rotation: ${this.rotationAmount}deg`, `${base}-width: ${width}px`, `${base}-height: ${height}px`, `${base}-aspect-ratio: ${aspectRatio}`, `${base}-dominant-color: #${dominantColor}`, `${base}-full-size-url: url(${encodeURI(fullsizeURL)})`);
    return htmlSafe(variables.filter(Boolean).join(";"));
  }
  get HTMLClassList() {
    const base = "d-lightbox";
    const classNames = [base];
    if (!this.isVisible) {
      return classNames.join("");
    }
    classNames.push(this.layoutType && `is-${this.layoutType}`, this.isVisible && `is-visible`, this.isLoading ? `is-loading` : `is-finished-loading`, this.isFullScreen && `is-fullscreen`, this.isZoomed && `is-zoomed`, this.isRotated && `is-rotated`, this.canZoom && `can-zoom`, this.hasExpandedTitle && `has-expanded-title`, this.hasCarousel && `has-carousel`, this.hasLoadingError && `has-loading-error`, this.willClose && `will-close`, this.isRotated && this.rotationAmount && `is-rotated-${this.rotationAmount}`);
    return classNames.filter(Boolean).join(" ");
  }
  get shouldDisplayMainImageArrows() {
    return !this.options.isMobile && this.canNavigate && !this.hasCarousel && !this.isZoomed && !this.isRotated;
  }
  get shouldDisplayCarousel() {
    return this.hasCarousel && this.totalItemCount >= this.options.minCarouselItemCount && !this.isZoomed && !this.isRotated;
  }
  get shouldDisplayCarouselArrows() {
    return !this.options.isMobile && this.totalItemCount >= this.options.minCarouselArrowItemCount;
  }
  get shouldDisplayTitle() {
    return !this.hasLoadingError && !this.isZoomed && !this.isRotated;
  }
  get totalItemCount() {
    return this.items?.length || 0;
  }
  get counterIndex() {
    return this.currentIndex ? this.currentIndex + 1 : 1;
  }
  get canNavigate() {
    return this.items?.length > 1;
  }
  get canZoom() {
    return !this.hasLoadingError && this.currentItem?.canZoom;
  }
  get canRotate() {
    return !this.hasLoadingError;
  }
  get canDownload() {
    return !this.hasLoadingError && this.options.canDownload;
  }
  get canFullscreen() {
    return !this.hasLoadingError;
  }
  get hasLoadingError() {
    return this.currentItem?.hasLoadingError;
  }
  get nextButtonIcon() {
    return this.options.isRTL ? "chevron-left" : "chevron-right";
  }
  get previousButtonIcon() {
    return this.options.isRTL ? "chevron-right" : "chevron-left";
  }
  get zoomButtonIcon() {
    return this.isZoomed ? "search-minus" : "search-plus";
  }
  registerAppEventListeners() {
    this.appEvents.on(LIGHTBOX_APP_EVENT_NAMES.OPEN, this.open);
    this.appEvents.on(LIGHTBOX_APP_EVENT_NAMES.CLOSE, this.close);
  }
  deregisterAppEventListeners() {
    this.appEvents.off(LIGHTBOX_APP_EVENT_NAMES.OPEN, this.open);
    this.appEvents.off(LIGHTBOX_APP_EVENT_NAMES.CLOSE, this.close);
  }
  open(_ref) {
    let {
      items,
      startingIndex,
      callbacks,
      options
    } = _ref;
    this.options = options;
    this.items = items;
    this.currentIndex = startingIndex;
    this.callbacks = callbacks;
    this.isLoading = true;
    this.isVisible = true;
    this.scrollPosition = window.scrollY;
    _assertClassBrand(_DLightbox_brand, this, _setCurrentItem).call(this, this.currentIndex);
    if (this.options.zoomOnOpen && this.currentItem?.canZoom && !this.currentItem?.isZoomed) {
      this.toggleZoom();
    }
    this.callbacks.onOpen?.({
      items: this.items,
      currentItem: this.currentItem
    });
  }
  close() {
    this.willClose = true;
    discourseLater(this.cleanup, this.animationDuration);
    this.callbacks.onClose?.();
  }
  centerZoomedBackgroundPosition(zoomedImageContainer) {
    return this.options.isMobile ? scrollParentToElementCenter({
      element: zoomedImageContainer,
      isRTL: this.options.isRTL
    }) : false;
  }
  zoomOnMouseover(event) {
    const zoomedImageContainer = event.target;
    const offsetX = event.offsetX;
    const offsetY = event.offsetY;
    const x = offsetX / zoomedImageContainer.offsetWidth * 100;
    const y = offsetY / zoomedImageContainer.offsetHeight * 100;
    zoomedImageContainer.style.backgroundPosition = x + "% " + y + "%";
  }
  toggleZoom() {
    if (this.isLoading || !this.canZoom) {
      return;
    }
    this.isZoomed = !this.isZoomed;
    document.querySelector(".d-lightbox__close-button")?.focus();
  }
  rotateImage() {
    this.rotationAmount = (this.rotationAmount + 90) % 360;
    this.isRotated = this.rotationAmount !== 0;
  }
  toggleFullScreen() {
    this.isFullScreen = !this.isFullScreen;
    return this.isFullScreen ? document.documentElement.requestFullscreen() : document.exitFullscreen();
  }
  downloadImage() {
    return createDownloadLink(this.currentItem);
  }
  openInNewTab() {
    return openImageInNewTab(this.currentItem);
  }
  reloadImage() {
    _assertClassBrand(_DLightbox_brand, this, _setCurrentItem).call(this, this.currentIndex);
  }
  toggleCarousel() {
    this.hasCarousel = !this.hasCarousel;
    requestAnimationFrame(setCarouselScrollPosition);
  }
  showNextItem() {
    _assertClassBrand(_DLightbox_brand, this, _setCurrentItem).call(this, this.currentIndex + 1);
  }
  showPreviousItem() {
    _assertClassBrand(_DLightbox_brand, this, _setCurrentItem).call(this, this.currentIndex - 1);
  }
  showSelectedImage(event) {
    const targetIndex = event.target.dataset?.lightboxItemIndex;
    return targetIndex ? _assertClassBrand(_DLightbox_brand, this, _setCurrentItem).call(this, Number(targetIndex)) : false;
  }
  toggleExpandTitle() {
    this.hasExpandedTitle = !this.hasExpandedTitle;
  }
  onKeydown(event) {
    if (event.key === KEYBOARD_SHORTCUTS.CLOSE) {
      event.preventDefault();
      event.stopPropagation();
      return this.close();
    }
  }
  onKeyup(_ref2) {
    let {
      key
    } = _ref2;
    if (KEYBOARD_SHORTCUTS.PREVIOUS.includes(key)) {
      return this.showPreviousItem();
    }
    if (KEYBOARD_SHORTCUTS.NEXT.includes(key)) {
      return this.showNextItem();
    }
    if (key === KEYBOARD_SHORTCUTS.ZOOM) {
      return this.toggleZoom();
    }
    if (key === KEYBOARD_SHORTCUTS.FULLSCREEN) {
      return this.toggleFullScreen();
    }
    if (key === KEYBOARD_SHORTCUTS.ROTATE) {
      return this.rotateImage();
    }
    if (key === KEYBOARD_SHORTCUTS.DOWNLOAD) {
      return this.downloadImage();
    }
    if (key === KEYBOARD_SHORTCUTS.CAROUSEL) {
      return this.toggleCarousel();
    }
    if (key === KEYBOARD_SHORTCUTS.TITLE) {
      return this.toggleExpandTitle();
    }
    if (key === KEYBOARD_SHORTCUTS.NEWTAB) {
      return this.openInNewTab();
    }
  }
  onTouchstart() {
    let event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Event;
    if (this.isZoomed) {
      return false;
    }
    this.touchstartX = event.changedTouches[0].screenX;
    this.touchstartY = event.changedTouches[0].screenY;
  }
  async onTouchend(event) {
    if (this.isZoomed) {
      return false;
    }
    event.stopPropagation();
    const touchendY = event.changedTouches[0].screenY;
    const touchendX = event.changedTouches[0].screenX;
    const swipeDirection = await getSwipeDirection({
      touchstartX: this.touchstartX,
      touchstartY: this.touchstartY,
      touchendX,
      touchendY
    });
    switch (swipeDirection) {
      case SWIPE_DIRECTIONS.LEFT:
        this.options.isRTL ? this.showNextItem() : this.showPreviousItem();
        break;
      case SWIPE_DIRECTIONS.RIGHT:
        this.options.isRTL ? this.showPreviousItem() : this.showNextItem();
        break;
      case SWIPE_DIRECTIONS.DOWN:
        this.close();
        break;
    }
  }
  cleanup() {
    if (this.isVisible) {
      this.hasCarousel = true;
      this.hasExpandedTitle = false;
      this.isLoading = false;
      this.items = [];
      this.currentIndex = 0;
      this.isZoomed = false;
      this.isRotated = false;
      this.rotationAmount = 0;
      if (this.isFullScreen) {
        this.toggleFullScreen();
        this.isFullScreen = false;
      }
      this.isVisible = false;
      this.willClose = false;
      this.resetScrollPosition();
      this.callbacks.onCleanup?.();
      this.callbacks = {};
      this.options = {};
    }
  }
  resetScrollPosition() {
    if (window.scrollY !== this.scrollPosition) {
      window.scrollTo({
        left: 0,
        top: parseInt(this.scrollPosition, 10),
        behavior: "instant"
      });
    }
  }
  willDestroy() {
    super.willDestroy(...arguments);
    this.cleanup();
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "appEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "items", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isVisible", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "currentIndex", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "currentItem", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isZoomed", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isRotated", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isFullScreen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "rotationAmount", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "hasCarousel", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "hasExpandedTitle", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "registerAppEventListeners", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "registerAppEventListeners"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deregisterAppEventListeners", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "deregisterAppEventListeners"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "open", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "centerZoomedBackgroundPosition", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "centerZoomedBackgroundPosition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleZoom", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "toggleZoom"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rotateImage", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "rotateImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleFullScreen", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "toggleFullScreen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "downloadImage", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "downloadImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openInNewTab", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "openInNewTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reloadImage", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "reloadImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleCarousel", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCarousel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showNextItem", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "showNextItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPreviousItem", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "showPreviousItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSelectedImage", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "showSelectedImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleExpandTitle", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "toggleExpandTitle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onKeydown", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "onKeydown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onKeyup", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "onKeyup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTouchstart", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "onTouchstart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTouchend", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "onTouchend"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cleanup", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "cleanup"), _class.prototype)), _class);
async function _setCurrentItem(index) {
  _assertClassBrand(_DLightbox_brand, this, _onBeforeItemChange).call(this);
  this.currentIndex = (index + this.totalItemCount) % this.totalItemCount;
  this.currentItem = await preloadItemImages(this.items[this.currentIndex]);
  _assertClassBrand(_DLightbox_brand, this, _onAfterItemChange).call(this);
}
function _onBeforeItemChange() {
  this.callbacks.onItemWillChange?.({
    currentItem: this.currentItem
  });
  this.isLoading = true;
  this.isZoomed = false;
  this.isRotated = false;
}
function _onAfterItemChange() {
  this.isLoading = false;
  if (this.currentItem.dominantColor) {
    setSiteThemeColor(this.currentItem.dominantColor);
  }
  setCarouselScrollPosition({
    behavior: "smooth"
  });
  this.callbacks.onItemDidChange?.({
    currentItem: this.currentItem
  });
  const nextItem = this.items[this.currentIndex + 1];
  return nextItem ? preloadItemImages(nextItem) : false;
}
export { DLightbox as default };
setComponentTemplate(TEMPLATE, DLightbox);